import React from 'react';
import { Building2, Stethoscope, Globe2, Microscope, Syringe, Bluetooth as Tooth } from 'lucide-react';
import './Hcp3.css';

const Hcp3: React.FC = () => {
  return (
    <div className="hcp3">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Hospital & Clinic Partnerships</h1>
          <p>Leading Healthcare Providers in Taiwan</p>
        </div>
      </div>

      {/* Main Hospitals Section */}
      <section className="hospitals-section">
        <div className="container">
          <h2 className="section-title">Premier Hospital Partners</h2>
          
          {/* Taipei Veterans General Hospital */}
          <div className="hospital-card">
            <div className="hospital-content">
              <div className="hospital-info">
                <Building2 className="hospital-icon" />
                <h3>Taipei Veterans General Hospital</h3>
                <p className="hospital-description">
                  Home to Taiwan's first Heavy Ion Therapy Center, providing cutting-edge cancer treatment
                  with state-of-the-art technology and expert medical care.
                </p>
                <div className="hospital-features">
                  <div className="feature">
                    <Microscope className="feature-icon" />
                    <span>Advanced Heavy Ion Therapy</span>
                  </div>
                  <div className="feature">
                    <Stethoscope className="feature-icon" />
                    <span>Comprehensive Cancer Care</span>
                  </div>
                </div>
                <a href="https://vghtpeimsc.tw/zh-tw/home" target="_blank" rel="noopener noreferrer" 
                   className="hospital-link">Visit Official Website</a>
              </div>
              <div className="hospital-media">
                <img 
                  src="https://images.unsplash.com/photo-1587351021759-3e566b6af7cc?auto=format&fit=crop&q=80&w=2000" 
                  alt="Modern Hospital Building"
                  loading="lazy"
                />
                <div className="video-container">
                  <iframe
                    src="https://www.youtube.com/embed/ZVq0GQ5HlIs"
                    title="Taipei Veterans General Hospital Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>

          {/* Chang Gung Memorial Hospital */}
          <div className="hospital-card">
            <div className="hospital-content">
              <div className="hospital-info">
                <Building2 className="hospital-icon" />
                <h3>Chang Gung Memorial Hospital</h3>
                <p className="hospital-description">
                  International Medical Center offering advanced proton therapy and comprehensive
                  healthcare services with world-class facilities.
                </p>
                <div className="hospital-features">
                  <div className="feature">
                    <Syringe className="feature-icon" />
                    <span>Proton Therapy Center</span>
                  </div>
                  <div className="feature">
                    <Globe2 className="feature-icon" />
                    <span>International Medical Services</span>
                  </div>
                </div>
                <a href="https://www.changgung.hospital/en/" target="_blank" rel="noopener noreferrer" 
                   className="hospital-link">Visit Official Website</a>
              </div>
              <div className="hospital-media">
                <img 
                  src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=2000" 
                  alt="Chang Gung Memorial Hospital"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dental Clinics Section */}
      <section className="clinics-section">
        <div className="container">
          <h2 className="section-title">Partner Dental Clinics</h2>
          <div className="clinics-grid">
            {/* Yue Ting Talent Smart Dental */}
            <div className="clinic-card">
              <Tooth className="clinic-icon" />
              <h3>Yue Ting Talent Smart Dental</h3>
              <p>Advanced dental care with cutting-edge technology and professional expertise.</p>
              <a href="https://yttsd.com" target="_blank" rel="noopener noreferrer" 
                 className="clinic-link">Visit Website</a>
            </div>

            {/* Jinshan Smile Dental Group */}
            <div className="clinic-card">
              <Tooth className="clinic-icon" />
              <h3>Jinshan Smile Dental Group</h3>
              <p>Comprehensive dental services with a focus on patient comfort and satisfaction.</p>
              <a href="https://www.smile-dental.tw/" target="_blank" rel="noopener noreferrer" 
                 className="clinic-link">Visit Website</a>
            </div>

            {/* Yu Jian Dental */}
            <div className="clinic-card">
              <Tooth className="clinic-icon" />
              <h3>Yu Jian Dental</h3>
              <p>Specialized dental care with personalized treatment plans and modern facilities.</p>
              <a href="https://www.yj.dental" target="_blank" rel="noopener noreferrer" 
                 className="clinic-link">Visit Website</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hcp3;